"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var chip_1 = require("../chip");
var chipsInput_1 = require("../chipsInput");
var infocon_1 = require("../infocon");
var draggable_1 = require("../draggable");
var autoComplete_1 = require("../autoComplete");
var DraggableChip = draggable_1.default(chip_1.Chip, { delay: 200 });
var ChipsAutoComplete = autoComplete_1.default(chipsInput_1.ChipsInput, { fill: false });
var Chips = /** @class */ (function (_super) {
    tslib_1.__extends(Chips, _super);
    function Chips(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onDeleteChip = function (value, label, item, id) {
            var _a = _this.props, onDelete = _a.onDelete, name = _a.name;
            onDelete(value, label, name, item, id);
            _this.dispatchChangeEvent();
        };
        _this.onClickHandlerChip = function (value, label) {
            var _a = _this.props, onHandlerClick = _a.onHandlerClick, name = _a.name;
            onHandlerClick && onHandlerClick(value, label, name);
        };
        _this.onDraggableStart = function (target) {
            _this.draggableChipIndex = _this.getChipIndexByValue(target.dataset.value);
            _this.restChips = utils_1.nodeListToArrayOf(_this.$el.querySelectorAll("[data-ui='chip']"));
            _this.setState({ dragging: true });
        };
        _this.onDraggableMove = function (e, target, position) {
            if (!_this.restChips) {
                return;
            }
            var nextState = {
                valueDragHover: null,
                valueDragPosition: null
            };
            for (var i = 0, len = _this.restChips.length; i < len; i++) {
                var chip = _this.restChips[i];
                var chipRect = chip.getBoundingClientRect();
                if (utils_1.isInRect(position, chipRect)) {
                    nextState.valueDragHover = chip.dataset.value;
                    nextState.valueDragPosition = _this.getHoverChipPosition(chipRect, position);
                    break;
                }
                var prevChip = _this.restChips[i - 1];
                var nextChip = _this.restChips[i + 1];
                var prevChipRect = prevChip && prevChip.getBoundingClientRect();
                var nextChipRect = nextChip && nextChip.getBoundingClientRect();
                if (utils_1.isInRectYAxis(position, chipRect)) {
                    if (position.x > chipRect.left + chipRect.width) {
                        if (!nextChipRect || !utils_1.isInRectYAxis(position, nextChipRect) || position.x < nextChipRect.left) {
                            nextState.valueDragHover = chip.dataset.value;
                            nextState.valueDragPosition = "after";
                            break;
                        }
                    }
                    else if (position.x < chipRect.left) {
                        if (!prevChipRect || !utils_1.isInRectYAxis(position, prevChipRect) || position.x > prevChipRect.width + prevChipRect.left) {
                            nextState.valueDragHover = chip.dataset.value;
                            nextState.valueDragPosition = "before";
                            break;
                        }
                    }
                }
            }
            if (_this.state.valueDragHover !== nextState.valueDragHover ||
                _this.state.valueDragPosition !== nextState.valueDragPosition) {
                _this.setState(nextState);
            }
        };
        _this.onDraggableEnd = function (e, target) {
            var _a = _this.props, chips = _a.chips, onOrder = _a.onOrder, name = _a.name;
            var _b = _this.state, valueDragHover = _b.valueDragHover, valueDragPosition = _b.valueDragPosition;
            if (valueDragHover && valueDragPosition) {
                var index = _this.getChipIndexByValue(valueDragHover, chips.filter(function (chip, idx) { return idx !== _this.draggableChipIndex; }));
                if (valueDragPosition === "before" && _this.draggableChipIndex < index) {
                    index -= 1;
                }
                else if (valueDragPosition === "after") {
                    index += 1;
                }
                index = utils_1.ensureValueInRange(index, { min: 0, max: chips.length - 1 });
                if (index !== _this.draggableChipIndex) {
                    var clonedChips = utils_1.clone(chips);
                    utils_1.moveElement(clonedChips, _this.draggableChipIndex, index);
                    onOrder(clonedChips);
                }
            }
            _this.setState({ dragging: false, valueDragHover: null, valueDragPosition: null });
            _this.restChips = null;
            _this.draggableChipIndex = null;
        };
        _this.resetToDeleteChip = function () {
            var toDeleteChipIndex = _this.state.toDeleteChipIndex;
            if (toDeleteChipIndex > -1) {
                _this.setState({ toDeleteChipIndex: -1 });
            }
        };
        _this.onChipsInputChange = function (e) {
            _this.resetToDeleteChip();
            var onInputChange = _this.props.onInputChange;
            onInputChange && onInputChange(e);
        };
        _this.onSelectAutoCompleteItem = function (value, label, isNew, autoCompleteInputName, item) {
            var _a = _this.props, onSelect = _a.onSelect, name = _a.name;
            _this.resetToDeleteChip();
            if (isNew && _this.getChipIndexByValue(value) > -1) {
                return;
            }
            onSelect(value, label, isNew, name, item);
            _this.dispatchChangeEvent();
        };
        _this.onFocus = function (e) {
            var onFocus = _this.props.onFocus;
            _this.setActive(true);
            onFocus(e);
        };
        _this.onBlur = function (e) {
            var onBlur = _this.props.onBlur;
            _this.setState({ toDeleteChipIndex: -1 });
            _this.setActive(false);
            onBlur(e);
        };
        _this.handleBackspaceOnEmptyQuery = function () {
            var chips = _this.props.chips;
            if (chips.length === 0) {
                return;
            }
            var toDeleteChipIndex = _this.state.toDeleteChipIndex;
            if (toDeleteChipIndex < 0) {
                _this.setState({ toDeleteChipIndex: chips.length - 1 });
            }
            else {
                var chip = chips[toDeleteChipIndex];
                if (chip) {
                    _this.onDeleteChip(_this.getItemValue(chip), _this.getItemLabel(chip), chip, toDeleteChipIndex);
                }
                _this.setState({ toDeleteChipIndex: -1 });
            }
        };
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            _this.$select = el;
            exposedRef && exposedRef(el);
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.draggableChipIndex = null;
        _this.$el = null;
        _this.$select = null;
        _this.restChips = null;
        _this.index = {};
        _this.state = {
            isOpen: false,
            dragging: false,
            valueDragHover: null,
            valueDragPosition: null,
            toDeleteChipIndex: -1
        };
        _this.initialize();
        return _this;
    }
    Chips.prototype.initialize = function () {
        this.indexDataSource(this.props.dataSource);
    };
    Chips.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.dataSource !== this.props.dataSource) {
            this.indexDataSource(nextProps.dataSource);
        }
    };
    Chips.prototype.indexDataSource = function (dataSource) {
        var _a = this.props, itemLabelKey = _a.itemLabelKey, itemValueKey = _a.itemValueKey;
        if (dataSource.length > 0 && dataSource[0] !== "string") {
            for (var i = 0, len = dataSource.length; i < len; i++) {
                this.index[dataSource[i][itemValueKey]] = dataSource[i][itemLabelKey];
            }
        }
    };
    Chips.prototype.dispatchChangeEvent = function () {
        var _this = this;
        var onChange = this.props.onChange;
        setTimeout(function () {
            if (_this.$select) {
                var event_1 = new Event("change", { bubbles: true });
                var onChangeListener_1 = function (e) {
                    _this.$select.removeEventListener("change", onChangeListener_1);
                    onChange(e);
                };
                _this.$select.addEventListener("change", onChangeListener_1);
                _this.$select.dispatchEvent(event_1);
            }
        });
    };
    Chips.prototype.getItemValue = function (item) {
        var itemValueKey = this.props.itemValueKey;
        return ["string", "number"].indexOf(typeof (item)) > -1 ? item : item[itemValueKey];
    };
    Chips.prototype.getItemLabel = function (item) {
        var _a = this.props, itemLabelKey = _a.itemLabelKey, labelFormatter = _a.labelFormatter;
        var label;
        if (["string", "number"].indexOf(typeof (item)) > -1) {
            label = this.index[item] || item;
        }
        else {
            label = item[itemLabelKey];
        }
        if (labelFormatter) {
            return labelFormatter(item, label);
        }
        return label;
    };
    Chips.prototype.getChipIndexByValue = function (value, chips) {
        chips = chips || this.props.chips;
        for (var i = 0, len = chips.length; i < len; i++) {
            if (this.getItemValue(chips[i]) === value) {
                return i;
            }
        }
        return -1;
    };
    Chips.prototype.getHoverChipPosition = function (chipRect, position) {
        return chipRect.width / 2 + chipRect.left >= position.x ? "before" : "after";
    };
    Chips.prototype.clearSelectedChipsFromDataSource = function () {
        var _this = this;
        var _a = this.props, dataSource = _a.dataSource, chips = _a.chips, allowDuplicates = _a.allowDuplicates;
        if (!chips.length || allowDuplicates) {
            return dataSource;
        }
        var chipValues = chips.map(function (chip) { return _this.getItemValue(chip); });
        return dataSource.filter(function (item) { return chipValues.indexOf(_this.getItemValue(item)) < 0; });
    };
    Chips.prototype.renderChips = function () {
        var _this = this;
        var _a = this.props, chips = _a.chips, theme = _a.theme, fill = _a.fill, blue = _a.blue, orange = _a.orange, purple = _a.purple, deepPurple = _a.deepPurple, invert = _a.invert, hideChipsWhenLoading = _a.hideChipsWhenLoading, isLoading = _a.isLoading, onHandlerClick = _a.onHandlerClick, linkFactory = _a.linkFactory, readOnly = _a.readOnly, allowDuplicates = _a.allowDuplicates, colorPerChip = _a.colorPerChip;
        if (isLoading && hideChipsWhenLoading) {
            return null;
        }
        var _b = this.state, valueDragHover = _b.valueDragHover, valueDragPosition = _b.valueDragPosition, toDeleteChipIndex = _b.toDeleteChipIndex;
        var value;
        var label;
        var allowOrder = this.props.allowOrder && chips.length > 1;
        return chips.map(function (chip, idx) {
            var _a, _b;
            value = _this.getItemValue(chip);
            label = _this.getItemLabel(chip);
            var dragHover = value === valueDragHover;
            var id = allowDuplicates ? idx : value;
            var props = {
                item: chip,
                key: id,
                id: id,
                value: value,
                label: label,
                fill: fill,
                invert: invert,
                hideDeleteButton: readOnly,
                className: classnames_1.default(theme.chip, (_a = {},
                    _a[theme["will-delete"]] = idx === toDeleteChipIndex,
                    _a)),
                onDelete: _this.onDeleteChip
            };
            if (colorPerChip && chip.chipColor) {
                props[chip.chipColor] = true;
            }
            else {
                props.blue = blue;
                props.orange = orange;
                props.deepPurple = deepPurple;
                props.purple = purple;
            }
            var link = (typeof (chip) !== "string" && chip.link) || linkFactory(chip);
            if (onHandlerClick || link) {
                props.onHandlerClick = _this.onClickHandlerChip;
                props.handlerIconName = chip.handlerIconName || "icon-go-to-link-small";
                link && (props.link = link);
            }
            if (allowOrder) {
                props.onDraggableStart = _this.onDraggableStart;
                props.onDraggableMove = _this.onDraggableMove;
                props.onDraggableEnd = _this.onDraggableEnd;
                props.className = classnames_1.default(theme.chip, (_b = {},
                    _b[theme["chip-mark-before"]] = dragHover && valueDragPosition === "before",
                    _b[theme["chip-mark-after"]] = dragHover && valueDragPosition === "after",
                    _b[theme["will-delete"]] = idx === toDeleteChipIndex,
                    _b));
                return React.createElement(DraggableChip, tslib_1.__assign({}, props));
            }
            return React.createElement(chip_1.Chip, tslib_1.__assign({}, props));
        });
    };
    Chips.prototype.setActive = function (active) {
        if (this.state.active !== active) {
            this.setState({ active: active });
        }
    };
    Chips.prototype.renderHeader = function () {
        var _a = this.props, theme = _a.theme, label = _a.label, info = _a.info, infoPosition = _a.infoPosition, clearAllText = _a.clearAllText, onClearAll = _a.onClearAll, chips = _a.chips;
        var empty = !chips.length;
        var shouldRender = label || info || (clearAllText && onClearAll);
        if (shouldRender) {
            return (React.createElement("div", { className: theme.header },
                React.createElement("div", { className: theme.description },
                    label ? React.createElement("div", { className: theme.label }, label) : null,
                    info ? React.createElement(infocon_1.Infocon, { className: theme.infocon, title: info, position: infoPosition }) : null),
                React.createElement("div", { className: theme.headerButtons }, clearAllText && onClearAll ? (React.createElement("button", { className: theme.clear, onClick: onClearAll, disabled: empty }, clearAllText)) : null)));
        }
        return null;
    };
    Chips.prototype.renderAutoComplete = function () {
        var _a = this.props, theme = _a.theme, showAutoCompleteLoader = _a.showAutoCompleteLoader, autoCompleteListWidth = _a.autoCompleteListWidth, chips = _a.chips, maxItems = _a.maxItems, leaveOpenAfterSelect = _a.leaveOpenAfterSelect, allowCreate = _a.allowCreate, allowMultiCreate = _a.allowMultiCreate, emptyPlaceholder = _a.emptyPlaceholder, searchPlaceholder = _a.searchPlaceholder, loadingPlaceholder = _a.loadingPlaceholder, itemLabelKey = _a.itemLabelKey, itemValueKey = _a.itemValueKey, selectValueOnBlur = _a.selectValueOnBlur, clearInputOnBlur = _a.clearInputOnBlur, isLoading = _a.isLoading, inputProps = _a.inputProps, labelFormatter = _a.labelFormatter, renderUnderAutoCompleteOptions = _a.renderUnderAutoCompleteOptions, focusInputAfterEnabled = _a.focusInputAfterEnabled, onSelectAll = _a.onSelectAll, renderList = _a.renderList, filter = _a.filter;
        var empty = !chips.length;
        var placeholder;
        if (isLoading) {
            placeholder = loadingPlaceholder;
        }
        else {
            placeholder = empty ? (emptyPlaceholder || searchPlaceholder) : searchPlaceholder;
        }
        return (React.createElement(ChipsAutoComplete, tslib_1.__assign({}, inputProps, { empty: empty, renderUnderList: renderUnderAutoCompleteOptions, maxItems: maxItems, labelFormatter: labelFormatter, onBlur: this.onBlur, onFocus: this.onFocus, onChange: this.onChipsInputChange, onSelectAll: onSelectAll, placeholder: placeholder, allowCreate: allowCreate, selectValueOnBlur: selectValueOnBlur, clearInputOnBlur: clearInputOnBlur, itemLabelKey: itemLabelKey, itemValueKey: itemValueKey, className: theme["auto-complete"], leaveOpenAfterSelect: leaveOpenAfterSelect, onSelectItem: this.onSelectAutoCompleteItem, dataSource: this.clearSelectedChipsFromDataSource(), onEmptyQueryBackspaceKey: this.handleBackspaceOnEmptyQuery, disabled: isLoading, focusAfterEnabled: focusInputAfterEnabled, isLoading: showAutoCompleteLoader, listWidth: autoCompleteListWidth, allowMultiCreate: allowMultiCreate, renderList: renderList, filter: filter })));
    };
    Chips.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, chips = _b.chips, invalid = _b.invalid, purple = _b.purple, deepPurple = _b.deepPurple, blue = _b.blue, orange = _b.orange, dataSource = _b.dataSource, required = _b.required, onInvalid = _b.onInvalid, onChange = _b.onChange, readOnly = _b.readOnly, validationMessage = _b.validationMessage;
        var active = this.state.active;
        var classes = classnames_1.default(theme.chips, className, (_a = {},
            _a[theme.active] = active,
            _a[theme.invalid] = invalid,
            _a[theme.empty] = !chips.length,
            _a[theme.purple] = purple,
            _a[theme.deepPurple] = deepPurple,
            _a[theme.blue] = blue,
            _a[theme.orange] = orange,
            _a));
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes, ref: this.setRef },
                this.renderHeader(),
                React.createElement("div", { className: theme.inner },
                    this.renderChips(),
                    dataSource && !readOnly ? this.renderAutoComplete() : null,
                    React.createElement("select", { tabIndex: -1, onChange: utils_1.noop, multiple: true, required: required, value: chips.map(function (chip) { return _this.getItemValue(chip); }), ref: this.setExposedRef, onInvalid: onInvalid }, dataSource.map(function (item, idx) { return React.createElement("option", { key: idx, value: _this.getItemValue(item) }, _this.getItemLabel(item)); })))),
            invalid && validationMessage ? React.createElement("div", { className: theme.validation }, validationMessage) : null));
    };
    Chips.defaultProps = {
        itemValueKey: "value",
        itemLabelKey: "label",
        onDelete: utils_1.noop,
        onSelect: utils_1.noop,
        onOpen: utils_1.noop,
        onClose: utils_1.noop,
        onFocus: utils_1.noop,
        onBlur: utils_1.noop,
        onOrder: utils_1.noop,
        onInvalid: utils_1.noop,
        onChange: utils_1.noop,
        linkFactory: utils_1.noop,
        chips: [],
        dataSource: [],
        searchPlaceholder: "Add Item...",
        loadingPlaceholder: "Loading..."
    };
    return Chips;
}(React.Component));
exports.default = Chips;
